import { render, staticRenderFns } from "./Units.vue?vue&type=template&id=45e76b3b&scoped=true&lang=pug&"
import script from "./Units.vue?vue&type=script&lang=ts&"
export * from "./Units.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e76b3b",
  null
  
)

export default component.exports